import { DEFAULT_CURRENCY } from "../../../../../config/app.config";
import {
  BookingTicketGeneratedEvent
} from "../../../../../shared/application/events/ticket/booking-ticket-generated.event";
import { Booking } from "../../../booking/domain/models/booking.model";
import { IEntryViewerViewState } from "../view-states/entry-viewer.view-state";
import { APP_ROUTE_PATH } from "../../../../enums/routes/app-route-path.enum";
import { SERVICE_ROUTE_PATH } from "../../../../enums/routes/service-route-path.enum";
import { ACCOUNT_ROUTE_PATH } from "../../../../enums/routes/account-route-path.enum";

export class EntryViewerMapper {
  private static readonly bookingRoutePath = `/${APP_ROUTE_PATH.service}/${SERVICE_ROUTE_PATH.account}/${ACCOUNT_ROUTE_PATH.bookings}`;

  static mapToState(
    activeBooking: Booking | null | undefined,
    ticketGenerated?: BookingTicketGeneratedEvent,
    isOffline?: boolean,
    currentUrl?: string,
  ): IEntryViewerViewState {
    return {
      isBookingSelected: !!activeBooking,
      isBookingLocked: (activeBooking?.isLockedByOther && !activeBooking.isActive) || false,
      isBookingClosed: Boolean(activeBooking?.isClosed),
      isPaymentResumeVisible: !!ticketGenerated,
      isCloseBookingButtonVisible: activeBooking?.canBeClosed || false,
      pendingBookingToBePaid: activeBooking?.financial.toBePaid || 0,
      pendingBookingConsumption: activeBooking?.financial.pendingConsumption || 0,
      currency: activeBooking?.financial.currency || DEFAULT_CURRENCY,
      isOffline: isOffline || false,
      isInBookingRoute: this.checkIsInBookingRoute(currentUrl),
    };
  }
  
  private static checkIsInBookingRoute(currentUrl?: string): boolean {
    return currentUrl?.includes(this.bookingRoutePath) ?? false;
  }
}
